"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InviteTemplates = exports.UuidPrefixes = exports.Scopes = exports.EventTypes = exports.TaskTypes = exports.Methods = exports.Constants = exports.USERAGENT = exports.JSON_REQUEST = void 0;
exports.JSON_REQUEST = "application/json";
exports.USERAGENT = "ocelot/1.0";
var Constants;
(function (Constants) {
    Constants["ENDPOINT"] = "https://api.deako.com/api/v2nobp";
    Constants["BACKEND_ENDPOINT"] = "https://deakoapi.deako.com";
    Constants["BACKEND_ENDPOINT_V2"] = "https://deakoapi.deako.com/v2";
    Constants["BACKEND_ENDPOINT_V2_ADMIN"] = "https://deakoapi.deako.com/v2/admin";
    Constants["BACKEND_STAGING_ENDPOINT"] = "https://backend-canary.deako.com";
    Constants["STAGING"] = "https://api-stg.deako.com/api/v2s";
    Constants["AUTH0_API_TOKEN_ENDPOINT"] = "https://admin.xx.deako.com/token0/token";
    Constants["GROUPS"] = "groups";
    Constants["SCENES"] = "scenes";
    Constants["LOAD"] = "loads";
    Constants["USER"] = "users";
    Constants["SCHEDULES"] = "schedules";
    Constants["STATE"] = "loadstate";
    Constants["SWITCHSTATE"] = "switchstate";
    Constants["DIAGNOSTICS"] = "diagnostics";
    Constants["REMOTEURL"] = "mesh/urls";
    Constants["UPDATE"] = "update";
    Constants["UPDATE_START"] = "update/start";
    Constants["SWITCH"] = "switches";
    Constants["BACKPLATE"] = "backplates?create_faceplate=true";
    Constants["CUSTOMER"] = "tradegecko/customers";
    Constants["ADDRESS"] = "addresses";
    Constants["ORDERS"] = "orders";
    Constants["EVENTS"] = "events";
    Constants["V1_CHANNELS"] = "v1/channels";
    Constants["V2_CHANNELS"] = "v2/channels";
    Constants["V2_BUILDS"] = "v2/build";
    Constants["V1_PROFILES_LIST"] = "v1/profile_list";
})(Constants = exports.Constants || (exports.Constants = {}));
var Methods;
(function (Methods) {
    Methods["DELETE"] = "DELETE";
    Methods["GET"] = "GET";
    Methods["PUT"] = "PUT";
    Methods["POST"] = "POST";
})(Methods = exports.Methods || (exports.Methods = {}));
var TaskTypes;
(function (TaskTypes) {
    TaskTypes["ADD_HANDLE_V1"] = "addHandle:v1";
    TaskTypes["ADD_DEVICE_V1"] = "addDevice:v1";
    TaskTypes["ADD_DEVICE_V2"] = "addDevice:v2";
    TaskTypes["ADD_SIMPLE"] = "addSimple:v1";
    TaskTypes["EDIT_DEVICE_V1"] = "editDevice:v1";
    TaskTypes["REMOVE_DEVICE_V1"] = "deleteDevice:v1";
    TaskTypes["EDIT_USER_V1"] = "editUser:v1";
    TaskTypes["ADD_SCHEDULE_V1"] = "addSchedule:v1";
    TaskTypes["ADD_SCHEDULE_V2"] = "addSchedule:v2";
    TaskTypes["EDIT_SCHEDULE_V1"] = "editSchedule:v1";
    TaskTypes["EDIT_SCHEDULE_V2"] = "editSchedule:v2";
    TaskTypes["DELETE_SCHEDULE_V2"] = "deleteSchedule:v2";
    TaskTypes["INVITE_V1"] = "invite:v1";
    TaskTypes["EDIT_PROFILE_V1"] = "editProfile:v1";
    TaskTypes["EDIT_MEMBERSHIP_V1"] = "editMembership:v1";
    TaskTypes["DELETE_MEMBERSHIP_V1"] = "deleteMembership:v1";
    TaskTypes["ADD_GEN1_SWITCH_V1"] = "addGen1Switch:v1";
    TaskTypes["DELETE_GEN1_SWITCH_V1"] = "deleteGen1Switch:v1";
})(TaskTypes = exports.TaskTypes || (exports.TaskTypes = {}));
var EventTypes;
(function (EventTypes) {
    EventTypes["CREATE_PROFILE_V1"] = "intent.createProfile:v1";
    EventTypes["UPDATE_CHANNEL"] = "intent.update.channel";
    EventTypes["CREATE_USER_V1"] = "user.create:v1";
})(EventTypes = exports.EventTypes || (exports.EventTypes = {}));
var Scopes;
(function (Scopes) {
    Scopes["MESH"] = "mesh";
})(Scopes = exports.Scopes || (exports.Scopes = {}));
exports.UuidPrefixes = {
    profileId: "profile-",
    devices: (device) => `${device}-`,
};
var InviteTemplates;
(function (InviteTemplates) {
    InviteTemplates["LEGACY_V1"] = "legacy_invitation_v1";
    InviteTemplates["INVITE_V2"] = "inviteV2";
})(InviteTemplates = exports.InviteTemplates || (exports.InviteTemplates = {}));
//# sourceMappingURL=Paths.js.map